import React, { useEffect, useRef } from 'react';
import Swiper from 'swiper';
import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import YoutubeVideo from '../YoutubeVideo';
import { ToLeft, ToRight } from './navigation';

import {
  Wrapper,
  GalleryWrapper,
  ThumbnailsWrapper,
  ThumbnailSlidersWrapper,
} from './styled';

const slidesPerView = 4;

function Gallery({ color, youtube, fluids }) {
  // TODO: IMPORTANT! White is by default if redux items is not available on first load.
  const colorSelected = color || 'white';
  const galleryRef = useRef();
  const thumbsRef = useRef();
  const toLeftRef = useRef();
  const toRightRef = useRef();

  useEffect(() => {
    const thumbsSwiper = new Swiper(thumbsRef.current, {
      spaceBetween: 12,
      slidesPerView,
      slideToClickedSlide: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      grabCursor: true,
      preloadImages: true,
    });

    const gallerySwiper = new Swiper(galleryRef.current, {
      spaceBetween: 12,
      navigation: {
        nextEl: toRightRef.current,
        prevEl: toLeftRef.current,
      },
      thumbs: {
        swiper: thumbsSwiper,
      },
      grabCursor: true,
      preloadImages: true,
    });

    return () => {
      gallerySwiper.destroy();
      thumbsSwiper.destroy();
    };
  }, [colorSelected, youtube, fluids]);

  const images = (fluids.get(colorSelected) || []).concat(fluids.get('common'));

  return (
    <Wrapper id="wrapper-new">
      <GalleryWrapper>
        <div className="swiper-container" ref={galleryRef}>
          <div className="swiper-wrapper">
            {images.map((image, i) => (
              <GatsbyImage
                image={image}
                loading="eager"
                // eslint-disable-next-line react/no-array-index-key
                key={i}
                className="swiper-slide"
                alt=""
              />
            ))}
            {youtube && (
              <div className="swiper-slide">
                <YoutubeVideo
                  inSlider
                  url={youtube.url}
                  aspectRatio={youtube.aspectRatio}
                  title={youtube.title}
                />
              </div>
            )}
          </div>
        </div>
      </GalleryWrapper>
      <ThumbnailsWrapper>
        <ToLeft ref={toLeftRef} />
        <ThumbnailSlidersWrapper>
          <div className="swiper-container" ref={thumbsRef}>
            <div className="swiper-wrapper">
              {images.map((fluid, i) => (
                <GatsbyImage
                  image={fluid}
                  loading="eager"
                  // eslint-disable-next-line react/no-array-index-key
                  key={i}
                  className="swiper-slide"
                  alt=""
                />
              ))}
              {youtube && (
                <GatsbyImage
                  image={youtube.fluid}
                  loading="eager"
                  className="swiper-slide"
                  alt=""
                />
              )}
            </div>
          </div>
        </ThumbnailSlidersWrapper>
        <ToRight ref={toRightRef} />
      </ThumbnailsWrapper>
    </Wrapper>
  );
}

Gallery.defaultProps = {
  color: 'white',
  youtube: null,
};

Gallery.propTypes = {
  // eslint-disable-next-line react/require-default-props
  color: PropTypes.string,
  youtube: PropTypes.exact({
    url: PropTypes.string.isRequired,
    aspectRatio: PropTypes.number.isRequired,
    fluid: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
  }),
  fluids: PropTypes.instanceOf(Map).isRequired,
};

export default Gallery;
